/* import __COLOCATED_TEMPLATE__ from './language-detection-details.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type LanguageDetectionDetails from 'embercom/objects/inbox/renderable/language-detection-details';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Conversation from 'embercom/objects/inbox/conversation';
import type Session from 'embercom/services/session';
import LinkWithText from 'embercom/helpers/link-with-text';
import type RouterService from '@ember/routing/router-service';
import { createSafeAdminLink } from 'embercom/utils/admin-link';

export interface LanguageDetectionDetailsPart extends RenderablePart {
  renderableData: LanguageDetectionDetails;
}

export interface Args {
  part: LanguageDetectionDetailsPart;
  conversation: Conversation;
}

export interface Signature {
  Args: Args;
}

export default class LanguageDetectionDetailsPartComponent extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare session: Session;
  @service declare router: RouterService;

  // @ts-ignore helper doesn't seem to be typed correctly
  linkWithTextHelper = LinkWithText.create(this);

  get fallbackLocale() {
    return this.args.part.renderableData.fallbackLocale;
  }

  get fallbackLanguage() {
    return this.intl.languageNameFromCode(this.fallbackLocale);
  }

  get renderableData() {
    return this.args.part.renderableData;
  }

  get operatorName() {
    return createSafeAdminLink(
      this.args.part.renderableData.creatingEntity.object,
      this.linkWithTextHelper,
    );
  }

  get fallbackLanguageTranslationKey(): string {
    return 'inbox.language-detection-details.fallback-language-v2';
  }

  get languageOverrideTranslationKey(): string {
    return 'inbox.language-detection-details.language-override-v2';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::LanguageDetectionDetails': typeof LanguageDetectionDetailsPartComponent;
    'inbox2/conversation-stream/event-parts/language-detection-details': typeof LanguageDetectionDetailsPartComponent;
  }
}
